import React from 'react'

import { StyledRemoteString } from '@acorns/web-utils'

import { FlowRoute } from 'utils/FlowProvider/types'

export const MOC_ONBOARDING_HERO_COPY = new Map([
  [
    FlowRoute.MOCInterstitial,
    {
      header: 'Mighty Oak Card',
    },
  ],
  [
    FlowRoute.MOCProgressStepOne,
    {
      header: 'Mighty Oak Card',
    },
  ],
  [
    FlowRoute.PersonalInfo,
    {
      header: 'Tell us a little about you',
      text: <StyledRemoteString stringKey="registration.personal_information.subtitle" />,
      footnote: <StyledRemoteString stringKey="round_ups.secured_view.title" />,
      footnoteLock: true,
    },
  ],

  [
    FlowRoute.ContactInfo,
    {
      header: <StyledRemoteString stringKey="registration.contact_info.title" />,
      text: <StyledRemoteString stringKey="registration.contact_info.body" />,
      footnote: <StyledRemoteString stringKey="registration.contact_info.body" />,
      footnoteLock: true,
      footerText: 'Standard message rates may apply.',
    },
  ],
  [
    FlowRoute.MFASetup,
    {
      header: 'Verify Phone Number',
    },
  ],
  [
    FlowRoute.SSN,
    {
      header: <StyledRemoteString stringKey="registration.ssn_screen.title" />,
      text: (
        <>
          <strong>
            <StyledRemoteString stringKey="registration.ssn_screen.headline" />
          </strong>
        </>
      ),
      subtext: (
        <p>
          We’re legally required to ask for your SSN to open your account. We encrypt your data to
          keep your info safe.
        </p>
      ),
      footnote: 'Your info is encrypted.',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.InvestorQuestions,
    {
      header: 'More About You',
      text: (
        <>
          <strong>
            <StyledRemoteString stringKey="invest.onboarding.investor_questions.subtitle" />
          </strong>
        </>
      ),
    },
  ],
  [
    FlowRoute.MOCProgressStepTwo,
    {
      header: 'Mighty Oak Card',
    },
  ],
  [
    FlowRoute.PricingInterstitial,
    {
      header: 'Confirm your subscription tier',
    },
  ],
  [
    FlowRoute.CardOrderReview,
    {
      header: 'Review',
    },
  ],
  [
    FlowRoute.MOCProgressStepThree,
    {
      header: 'Mighty Oak Card',
    },
  ],
  [
    FlowRoute.SignYourCard,
    {
      header: 'Sign your card',
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      header: <StyledRemoteString stringKey="invest.onboarding.suitability.title" />,
      text: (
        <>
          <strong>Your finances and goals</strong>
        </>
      ),
      subtext: (
        <StyledRemoteString
          stringKey="invest.onboarding.suitability.subtitle.v1.markdown"
          screen="registrationPortfolioQuestions"
        />
      ),
    },
  ],
  [
    FlowRoute.Occupation,
    {
      header: 'Add occupation',
    },
  ],
  [
    FlowRoute.ShippingAddress,
    {
      header: 'Shipping address',
    },
  ],
  [
    FlowRoute.PreviewPortfolio,
    {
      header: 'Recommended Portfolio',
    },
  ],
  [
    FlowRoute.CryptoLander,
    {
      header: <StyledRemoteString stringKey="invest.new_etf.lander.action_strip_title" />,
    },
  ],
  [
    FlowRoute.AboutPortfolio,
    {
      header: <StyledRemoteString stringKey="invest.portfolio.about.title_bar_title" />,
    },
  ],
  [
    FlowRoute.MOCReferralReminder,
    {
      header: <StyledRemoteString stringKey="registration.moc_referral_reminder.header" />,
    },
  ],
  [
    FlowRoute.Institutions,
    {
      header: 'Link your bank',
      text: 'Protected by bank-level security and 256-bit encryption.',
    },
  ],
  [
    FlowRoute.ReferralReward,
    {
      header: 'Your Reward',
    },
  ],
  [
    FlowRoute.ReferralDisclosure,
    {
      header: 'Referral Disclosure',
    },
  ],
  [
    FlowRoute.Success,
    {
      header: 'Success',
    },
  ],
  [
    FlowRoute.Funding,
    {
      header: 'Funding source',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      header: 'Link your bank',
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      header: 'Link your bank account',
      text:
        'We need a little more information to link your bank account, so you can fund your investments.',
      footnote: 'We use bank-level security, data encryption, and more.',
      mobileFootnote:
        'Your data is protected with 256-bit encryption and is never stored on your phone.',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.DirectBankIntegration,
    {
      header: 'Link Institution',
    },
  ],
  [
    FlowRoute.ChooseFundingSource,
    {
      header: 'Success',
    },
  ],
  [
    FlowRoute.BankLinkSuccess,
    {
      header: 'Success',
      title: 'Successfully linked',
      text:
        'Every time you add money to Acorns, it will transfer from your primary checking account.',
    },
  ],
  [
    FlowRoute.RecurringDeposit,
    {
      header: 'Make a deposit',
    },
  ],
  [
    FlowRoute.OneTimeDeposit,
    {
      header: 'One-time deposit',
    },
  ],
])
